import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isFormGroup: false,
}

const FormGroupSlice = createSlice({
  name: 'formGroupOrForm',
  initialState,
  reducers: {
    setIsFormGroup: (state, action) => {
      state.isFormGroup = action.payload
    }
  }
})

export const { setIsFormGroup } = FormGroupSlice.actions

export default FormGroupSlice.reducer